<template>
    <v-container fluid class="incidente-root">
        <div>
            <h2>Niveles</h2>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar por titulo" outlined dense></v-text-field>
            <v-divider class="mx-4" inset vertical></v-divider>  

            <!-- Diálogo para crear un nueva -->
            <v-dialog v-model="dialog" max-width="50%">
                <template v-slot:activator="{ on }">
                    <v-btn class="perfil-btn-primary" dark v-on="on" @click="nueva">Registrar</v-btn>
                </template>
                <v-card class="admin-form-card">
                    <v-card-title>
                        <v-icon left color="#f7c325">mdi-database-cog-outline</v-icon>
                        <span class="text-h5">{{ formTitle }}</span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="dialog = false"> <v-icon>mdi-close</v-icon> </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="form" v-model="formValid" lazy-validation>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="dato.nombre" label="Titulo" :rules="[rules.required]" clearable/>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <v-text-field v-model="dato.codigo" label="Código" :rules="[rules.required]" clearable/>
                                        </v-col>
                                        <v-col cols="12" md="12">
                                            <v-text-field v-model="dato.descripcion" label="Descripción" clearable/>
                                        </v-col>
                                    </v-row>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="perfil-btn-outline" outlined @click="dialog=false" :disabled="dialog_guardando"> Cancelar </v-btn>
                        <v-btn :loading="dialog_guardando" :disabled="!formValid || dialog_guardando" class="perfil-btn-primary" @click="guardar" >
                            {{ isNew ? 'Guardar' : 'Actualizar' }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-data-table :headers="headers" :items="filtered" item-key="oid" :items-per-page="30">
                <template v-slot:items="props">
                    <td>{{ props.item.nombre }}</td>
                    <td>{{ props.item.descripcion }}</td>
                </template>
                <template v-slot:item.fecha="{ item }">
                    {{ new Date(item.fecha).toLocaleString() }}
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-icon small class="mr-2" v-on="on" @click="mostrar(item.oid)">mdi-eye</v-icon>
                        </template>
                        <span>Detalle</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="item.tipo != 2">
                        <template v-slot:activator="{ on }">
                            <v-icon small class="mr-2" v-on="on" @click="editar(item)">mdi-pencil</v-icon>
                        </template>
                        <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="item.tipo != 2">
                        <template v-slot:activator="{ on }">
                            <v-icon small class="mr-2" color="red" v-on="on" @click="confirmarEliminar(item.oid)">mdi-delete</v-icon>
                        </template>
                        <span>Eliminar</span>
                    </v-tooltip>
                </template>
            </v-data-table>
        
            <!-- Formulario de creación/edición -->      
            <v-form ref="form" @submit.prevent="guardar">
            </v-form>

            <!-- Diálogo para ver detalle-->
            <v-dialog v-model="dialogdetail" max-width="50%">
                <v-card>
                <v-card-title>
                    <span>{{ formTitle }}</span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogdetail = false"> <v-icon>mdi-close</v-icon> </v-btn>
                </v-card-title> 
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-row>
                                <v-col cols="12">
                                    <h3 class="text-center" style="color: #e4b510;">Información General</h3>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <strong>Titulo:</strong><br>{{ dato.nombre }}
                                </v-col>
                                <v-col cols="12" md="2">
                                    <strong>Código:</strong><br>{{ dato.codigo }}
                                </v-col>
                                <v-col cols="12" md="3">
                                    <strong>Fecha Registro:</strong><br>{{ new Date(dato.fecha).toLocaleString() }}
                                </v-col>
                                <v-col cols="12" md="3">
                                    <strong>Usuario Creador:</strong><br>{{ getUserN(dato.oid_user) }}
                                </v-col>
                                <v-col cols="12" md="8">
                                    <strong>Descripción:</strong><br>{{ dato.descripcion }}
                                </v-col>
                            </v-row>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="secondary" text @click="dialogdetail = false;">Cerrar</v-btn>
                </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- Diálogo de confirmación para eliminar -->
            <v-dialog v-model="showConfirmDialog" max-width="500px">
                <v-card>
                <v-card-title class="headline">Confirmar eliminación</v-card-title>
                <v-card-text>
                    ¿Estás seguro de que deseas eliminar este registro?
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" text @click="eliminar(confirmItemId)">Sí</v-btn>
                    <v-btn color="secondary" text @click="cancelarEliminar">No</v-btn>
                </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- Dialogo para Mensaje cargando-->
            <v-dialog v-model="dialog_guardando" max-width="550px"> 
                <v-card>
                    <v-card-title class="headline">Guardando .....</v-card-title>
                </v-card>
            </v-dialog>
            
            <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="5000" top>
                {{ snackbarMensaje }}
                <template v-slot:action="{ attrs }">
                    <v-btn text v-bind="attrs" @click="snackbar = false">Cerrar</v-btn>
                </template>
            </v-snackbar>

        </div>
    </v-container>
</template>
  
<script>
import axios from 'axios';
import { setUsers, getUserN } from '@/utils/validators';
  
export default {
    data() {
        return {
            datos: [],
            dato: {
                oid: 0,
                nombre: '',
                descripcion: '',
                activo: true,
                tipo: null,
                codigo: '',
                oid_user: null,
                fecha: null,
            },
            isNew: true,
            dialog: false, // Controla la visibilidad del diálogo
            formTitle: '', // Título del diálogo
            dialogdetail: false,
            showConfirmDialog: false,
            confirmItemId: null,
            search: '', // Valor del campo de búsqueda
            dialog_guardando: false,
            snackbar: false,
            snackbarMensaje: '',
            snackbarColor: 'error',
            rules: {
                required: v => v !== null && v !== undefined && v !== '' || 'Requerido',
                maxValue: max => v =>
                    (!v || Number(v) <= max) || `El valor no puede ser mayor a ${max}`,
                select: v => (v !== null && v !== undefined && v !== '') || 'Selecciona una opción',
            },
            formValid: false,
        };
    },
    computed: {
            headers() {
                const baseHeaders = [
                    { text: 'Acciones', value: 'actions', sortable: false },
                    { text: 'Titulo', value: 'nombre' },
                    { text: 'Código', value: 'codigo' },
                    { text: 'Descripción', value: 'descripcion' },
                    { text: 'Usuario Creador', value: 'user' },
                    { text: 'Fecha Registro', value: 'fecha' },
                ];

                return baseHeaders;
            },
            filtered() {
                // Filtrar por el valor de búsqueda
                return this.datos.filter(dato =>
                    dato.nombre.toLowerCase().includes(this.search.toLowerCase())
                );
            },
            userName() {
                const user = localStorage.getItem('userName'); 
                return user;
            },
            rolOid() {
                const tipo = localStorage.getItem('rolu');
                return Number(tipo);
            },    
            userOid() {
                const oid_user = localStorage.getItem('oidu');
                return Number(oid_user);
            },
        },
    mounted() {
        this.listar();
    },
    methods: {
        // Obtener la lista
        async listar() {
            try {
                //await setNivels();
                await setUsers();

                const response = await axios.get('api/Nivels/Listar');
                this.datos = response.data.map(h => ({
                    ...h,
                    user: getUserN(h.oid_user)
                }));
            } catch (error) {
                console.error(error);
            }
        },
        // Mostrar detalles
        async mostrar(id) {
            try {
                const response = await axios.get(`api/Nivels/Mostrar/${id}`);
                this.dato = response.data;
                this.isNew = false;
                this.formTitle = 'Detalle Nivel';
                this.dialogdetail = true;
            } catch (error) {
                console.error(error);
            }
        },
        // Abrir el diálogo para crear una nuevo
        nueva() {
            this.dato = { 
                oid: 0,
                nombre: '',
                descripcion: '',
                activo: true,
                tipo: null,
                codigo: '',
                oid_user: null,
                fecha: null,
            };
            this.isNew = true;
            this.formTitle = 'Crear Nivel';
            this.dialog = true;
            this.$nextTick(() => {
                this.$refs.form && this.$refs.form.resetValidation();
                this.formValid= false;
            });
        },
        // Abrir el diálogo para actualizar
        editar(dato) {
            this.dato = { ...dato };
            this.isNew = false;
            this.formTitle = 'Actualizar Nivel';
            this.dialog = true;
        },
        // Guardar creada o actualizada
        async guardar() {
            // VALIDACION
            const ok = this.$refs.form && this.$refs.form.validate();
            if (!ok) return;

            this.dialog_guardando = true;
            this.dato.oid_user = this.userOid;
            try {        
                if (this.isNew) {
                    // Crear el área
                    const respuestaCrear = await axios.post('api/Nivels/Crear', this.dato);
                } else {
                    // Actualizar el área
                    await axios.put(`api/Nivels/Actualizar`, this.dato);
                }

                // Reset del formulario
                if (this.$refs.form) {
                    this.$refs.form.reset();
                    this.$refs.form.resetValidation();
                }

                // Limpiar el formulario después de guardar o actualizar
                this.dato = { 
                    oid: 0,
                    nombre: '',
                    descripcion: '',
                    activo: true,
                    tipo: null,
                    codigo: '',
                    oid_user: null,
                    fecha: null,
                };

                // Después de guardar exitosamente el registro:
                this.dialog = false;
                await this.listar();
                
                this.snackbarMensaje = "Registro guardado correctamente";
                this.snackbarColor = "success";
                this.snackbar = true;
            }catch(error) {
                console.error(error);
                this.snackbarMensaje = "Error al guardar registro.";
                this.snackbarColor = "error";
                this.snackbar = true;
            } finally {
                // Independientemente de si la solicitud tuvo éxito o no, detenemos el Nivel de carga.
                this.dialog_guardando = false;
            }
        },
        // Eliminar
        async eliminar(id) {
            try {
                await axios.delete(`api/Nivels/Eliminar/${id}`);
                this.listar();
                this.cancelarEliminar();
            } catch (error) {
                console.error(error);
            }
        },
        // Confirmar eliminación
        confirmarEliminar(id) {
            this.confirmItemId = id;
            this.showConfirmDialog = true;
        },
        // Cancelar eliminación
        cancelarEliminar() {
            this.confirmItemId = null;
            this.showConfirmDialog = false;
        },
        getUserN,
    },
};
</script> 
<style>
    p {
        font-family: 'Gotham', !important;
    }
    h1 {
        font-family: 'Gotham', !important;
    }

    .incidente-root {
        padding-top: 0 !important;
        margin-top: 0 !important;
        width: 100% !important;
        align-self: flex-start !important;
        margin-left: 1%;
    }
</style>

